import React from 'react';
import { getLabel } from '../../../data/labels';
import './ShareModalV2.css';

function ShareModalV2(props) {
    const {
        onClose,
        onShareLink,
        onPrint,
        onSaveImage,
        copyLinkText,
        downloadStatus,
        backgrounds,
        selectedBgId,
        onSelectBg,
        hideStake,
        onToggleStake,
        hideWinnings,
        onToggleWinnings,
        assetsReady = true,
    } = props;

    const canSave = assetsReady && downloadStatus === 'idle';

    // Da portare su desc entità
    const saveLabel = () => {
        if (!assetsReady) return getLabel('checkbet.preparing', 'Preparazione...');
        if (downloadStatus === 'loading') return getLabel('checkbet.generating', 'Generazione...');
        if (downloadStatus === 'error') return getLabel('checkbet.download_error', 'Errore di download');
        return getLabel('checkbet.download', 'Salva immagine');
    };

    return (
        <div id="share-modal-v2">
            <div className="smv2__backdrop" onClick={onClose} />
            <div className="smv2__sheet">
                <div className="smv2__header">
                    <h3 className="smv2__title">
                        {getLabel('betslip.reservation.share_bet', 'Condividi giocata')}
                    </h3>
                    <button className="smv2__close" onClick={onClose}>✕</button>
                </div>
                <p className="smv2__desc">
                    {getLabel('betslip.reservation.share_bet_desc', 'Condividi il link della tua giocata, scarica la ricevuta oppure salva un\'immagine personalizzata della schedina.')}
                </p>
                <button className="smv2__btn smv2__btn--primary" onClick={onShareLink}>
                    {copyLinkText || getLabel('betslip.reservation.share_link', 'Condividi link giocata')}
                </button>
                <button className="smv2__btn smv2__btn--secondary" onClick={onPrint}>
                    <i className='smv2__icon-print'></i>
                     {getLabel('reservation_detail.print', 'Stampa ricevuta')}
                </button>
                <hr className="smv2__divider" />
                <p className="smv2__section-title">
                    {getLabel('checkbet.share_modal_download_image_title', 'Scarica immagine giocata')}
                </p>

                {backgrounds && backgrounds.length > 0 && (
                    <>
                        <p className="smv2__bg-label">
                            {getLabel('checkbet.share_modal.choose_bg', 'Scegli sfondo')}
                        </p>
                        <div className="smv2__bg-row">
                            {backgrounds.map((bg) => (
                                <div
                                    key={bg.id}
                                    className={`smv2__bg-item ${selectedBgId === bg.id ? 'smv2__bg-item--selected' : ''}`}
                                    style={
                                        bg.imageUrl
                                            ? { backgroundImage: `url(${bg.imageUrl})` }
                                            : { backgroundColor: bg.color }
                                    }
                                    onClick={() => onSelectBg(bg.id)}
                                />
                            ))}
                        </div>
                    </>
                )}

                <div className="smv2__toggle-row">
                    <label className="smv2__toggle">
                        <input
                            type="checkbox"
                            checked={!hideStake}
                            onChange={onToggleStake}
                        />
                        <span className="smv2__toggle-slider" />
                    </label>
                    <span className="smv2__toggle-label">
                        {getLabel('checkbet.share_modal_show_stake', 'Mostra importo giocato')}
                    </span>
                </div>

                <div className="smv2__toggle-row">
                    <label className="smv2__toggle">
                        <input
                            type="checkbox"
                            checked={!hideWinnings}
                            onChange={onToggleWinnings}
                        />
                        <span className="smv2__toggle-slider" />
                    </label>
                    <span className="smv2__toggle-label">
                        {getLabel('checkbet.share_modal_show_winnings', 'Mostra vincita')}
                    </span>
                </div>

                <button
                    className={[
                        'smv2__btn smv2__btn--save',
                        !assetsReady ? 'smv2__btn--preparing' : '',
                        downloadStatus === 'loading' ? 'smv2__btn--loading' : '',
                        downloadStatus === 'error' ? 'smv2__btn--error' : '',
                    ].filter(Boolean).join(' ')}
                    onClick={canSave ? onSaveImage : undefined}
                    disabled={!canSave}
                >
                    {saveLabel()}
                </button>

            </div>
        </div>
    );
}

export default ShareModalV2;